import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getBusinessTilaajavastuuIntegrationStatus = async (businessId) => {
  const apiPath = `project-bank/business/${businessId}/tilaajavastuu-integration-status`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  return response.data;
};
